import { logout } from "../../common/Authenticator";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      await logout(); // Wait for logout to complete
     
      navigate("/login"); // Redirect to login page
    };
    
    handleLogout();
  }, [navigate]);

  return null; // No UI needed for this component
};

export default Logout;
